import { actions, reducer } from './form.slice';
import * as selector from './form.selector';

export default { actions, reducer, selector };
